// import Header from "../Header/Header";
import React from 'react';
import { motion } from 'framer-motion';
// import Header from "../Header/Header";
import CoursesHero from "./CourseHero";
import Course from "./Course";

const GraduateCourseDetails = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex flex-col"
    >
      {/* <Header /> */}
      <CoursesHero />
      <Course />
    </motion.div>
  );
};

export default GraduateCourseDetails;